import { HeartHandshake, GraduationCap, Sparkles, Users } from "lucide-react";

const WhyCard = ({ icon: Icon, title, body, testid }) => (
    <div
        className="bento-card bg-white rounded-2xl p-7 border border-[#E5DFD3] flex flex-col h-full"
        data-testid={testid}
    >
        <div className="h-11 w-11 rounded-xl bg-[#E8EFE8] grid place-items-center text-[#0E2A47] mb-5">
            <Icon className="h-5 w-5" />
        </div>
        <h3 className="font-[Outfit] text-[19px] font-semibold tracking-tight mb-2">
            {title}
        </h3>
        <p className="text-[14.5px] leading-relaxed text-[#6F6B63]">{body}</p>
    </div>
);

const APPROACH = [
    {
        icon: HeartHandshake,
        title: "Therapeutic Support",
        body: "Access to clinical and behavioral health services that help each youth stabilize, regulate, and heal.",
        testid: "why-therapeutic",
    },
    {
        icon: GraduationCap,
        title: "Educational Coordination",
        body: "Close partnership with schools, caregivers, and care teams to keep each youth engaged and progressing academically.",
        testid: "why-education",
    },
    {
        icon: Sparkles,
        title: "Life Skills Development",
        body: "Daily routines that build hygiene, responsibility, communication, conflict resolution, and independent living skills.",
        testid: "why-life-skills",
    },
    {
        icon: Users,
        title: "Relationship-Based Care",
        body: "A trauma-informed, TBRI-informed approach prioritizing connection, safety, correction, and consistency.",
        testid: "why-relationship",
    },
];

export default function ApproachSection() {
    return (
        <section className="py-20 md:py-24 bg-[#F7F5F0]">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="max-w-2xl mb-14">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        What we provide
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        The Crossroads Approach.
                    </h2>
                    <p className="mt-5 text-[16px] leading-relaxed text-[#6F6B63]">
                        At Crossroads to Change, we provide structured,
                        relationship-based, and trauma-informed support
                        designed to help young men heal, develop healthy
                        relationships, strengthen emotional regulation, and
                        prepare for successful futures. Our program focuses
                        on four key areas:
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {APPROACH.map((a) => (
                        <WhyCard key={a.testid} {...a} />
                    ))}
                </div>
            </div>
        </section>
    );
}
